var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('mini-header',{attrs:{"dense":true,"breadcrumbs":_vm.breadcrumbs,"hiddenTab":true,"addPadding":true}}),_c('v-row',{staticClass:"mt-16",attrs:{"align":"center"}},[_c('v-empty-state',{attrs:{"title":"En fase de creación","type":"create","id":"tiendas","customClass":"mt-7","height":300,"hiddenDescription":true,"isFree":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }